"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseLayer = void 0;
var Map_1 = require("ol/Map");
var BaseLayer = /** @class */ (function () {
    function BaseLayer(_ref, _displayName, _layer) {
        this._ref = _ref;
        this._displayName = _displayName;
        this._layer = _layer;
    }
    Object.defineProperty(BaseLayer.prototype, "ref", {
        get: function () {
            return this._ref;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseLayer.prototype, "displayName", {
        get: function () {
            return this._displayName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseLayer.prototype, "olLayer", {
        get: function () {
            return this._layer;
        },
        enumerable: false,
        configurable: true
    });
    BaseLayer.prototype.addLayerToMap = function (map, visibility) {
        this.setVisible(visibility);
        if (map instanceof Map_1.default) {
            map.addLayer(this._layer);
        }
        else {
            map.olMap.addLayer(this._layer);
        }
    };
    BaseLayer.prototype.setVisible = function (visible) {
        return this._layer.setVisible(visible);
    };
    BaseLayer.prototype.getVisible = function () {
        return this._layer.getVisible();
    };
    BaseLayer.prototype.setOpacity = function (opacity) {
        this._layer.setOpacity(opacity);
    };
    return BaseLayer;
}());
exports.BaseLayer = BaseLayer;
//# sourceMappingURL=BaseLayer.js.map